import WorkerApiService from "../workerApiServices";

class AuditoriaService extends WorkerApiService {

    constructor() {
        super('/api/auditoria')
    }

    findAllByLancamentoBancario(idLancamentoBancario) {
        return this.get(`/lancamentoBancario/${idLancamentoBancario}`)
    }
}

export default AuditoriaService
